export const mutations = {
  SET_COMFORT_VALUES(state, value) {
    state.comfortValues = value;
  },

  SET_COMFORT_IS_LOADED(state, value) {
    state.comfortIsLoaded = value;
  },
};
